<template>
    <div id="cyclic-list">
        <v-dialog
                max-width="290"
                v-model="dialog"
        >
            <v-card>
                <v-card-title class="headline">Jestes pewien?</v-card-title>
                <v-card-text>
                    Czy na pewno chcesz usunac cykl ?
                </v-card-text>
                <v-card-text>
                    Jesli formularze zostały przesłane w tym cyklu, cykl nie zostanie usuniety!
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="dialog = false"
                            color="green darken-1"
                            text
                    >
                        Anuluj
                    </v-btn>
                    <v-btn
                            @click="deleteItem()"
                            color="green darken-1"
                            text
                    >
                        Usun
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-app id="inspire">
            <div>
                <v-btn @click="create" class="mb-2" color="primary" dark>{{ $t('cycle.create') }}</v-btn>

                <v-select
                        :items="teams"
                        :label="`${$t('cyclic.teams')}`"
                        item-text="name"
                        item-value="id"
                        required
                        v-model="selectedTeam"
                >
                </v-select>
                <v-data-table
                        :headers="headers"
                        :items="cycles"
                        class="elevation-1"
                        hide-actions
                >
                    <template slot="items" slot-scope="props">
                        <td>{{ props.item.name }}</td>
                        <td class="text-xs">
                            <router-link :to="{ name:'cyclic-view', params: {'cyclicId':  props.item.cycle_definition.id  }}"
                                         class="link">
                                {{ props.item.cycle_definition.name }}
                            </router-link>
                        </td>
                        <td class="text-xs">{{ props.item.from }}</td>
                        <td class="text-xs">{{ props.item.to }}</td>
                        <td class="text-xs">{{ props.item.lazy | intToYesNo }}</td>
                        <td class="justify-center layout px-0">
                            <v-btn @click="viewItem(props.item)" class="mx-0" icon>
                                <v-icon color="green darken-3">pageview</v-icon>
                            </v-btn>
                            <v-btn @click="prepareToDelete(props.item)" class="mx-0" icon>
                                <v-icon color="black">delete</v-icon>
                            </v-btn>
                        </td>
                    </template>
                    <template slot="no-data">
                        <v-btn @click="loadCycle" color="primary">Reset</v-btn>
                    </template>
                </v-data-table>
            </div>
        </v-app>
    </div>
</template>

<script>
    import http from '@/plugins/http'

    export default {
        components: {},
        data: () => ({
            cycles: [],
            teams: [],
            selectedTeam: 0,
            cycleToDelete: {},
            dialog: false
        }),
        computed: {
            headers() {
                return [
                    {text: this.$t('cyclic.name'), align: 'left', sortable: false, value: 'name'},
                    {text: this.$t('cyclic.definition'), value: 'cycle_definition_id'},
                    {text: this.$t('cycle.from'), value: 'from'},
                    {text: this.$t('cycle.to'), value: 'to'},
                    {text: this.$t('cycle.once'), value: 'lazy'},
                ]
            }
        },
        watch: {
            // TODO POBRAWIC TO....na syzbko
            selectedTeam: function (newTeam) {
                http.get('cycle/index?team=' + newTeam)
                    .then(response => {
                        this.cycles = response.data
                    }).catch(() => {
                    this.cycles = [];
                })
            }
        },
        created() {
            this.loadCycle();
            this.loadTeams();
        },

        methods: {
            viewItem(item) {
                this.$router.push({'path': '/cycle/' + item.id + '/schemas'})
            },
            prepareToDelete(item) {
                this.cycleToDelete = item;
                this.dialog = true
            },
            deleteItem() {
                http.delete('cycle/' + this.cycleToDelete.id).then(() => this.cycles = this.cycles.filter((el) => el.id != this.cycleToDelete.id));
                this.dialog = false;
            },
            create() {
                this.$router.push({"path": "/cycle/create"})
            },
            loadCycle() {
                this.loading = true;
                http.get('cycle/index')
                    .then(response => {
                        this.cycles = response.data;
                        this.loading = false
                    }).catch(() => {
                    this.loading = false
                })
            },
            loadTeams() {
                this.loading = true;
                http.get('teams')
                    .then(({data}) => {
                        this.teams = data;
                    });
                this.loading = false
            },
        }
    }
</script>

<style>
    .link {
        text-decoration: none;
        color: black;
    }
</style>
